$(document).ready(function(){
  setTimeout(function () {
    $( ".hero_top_unit" ).toggleClass("show");
  }, 1200);
});
